var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"spinner__container"},[(_vm.isLoading)?[_c('img',{staticClass:"spinner__img",attrs:{"src":require("@/assets/images/icons/lazy-load-spinner.gif"),"alt":"loading..."}})]:_vm._e()],2),_c('div',{directives:[{name:"observe-visibility",rawName:"v-observe-visibility",value:({
      callback: function (isVisible) { return this$1.updateFunction(isVisible); },
      throttle: 300
  }),expression:"{\n      callback: (isVisible) => this.updateFunction(isVisible),\n      throttle: 300\n  }"}],staticClass:"detector"})])}
var staticRenderFns = []

export { render, staticRenderFns }